const TRANSITION_IN_SLIDE_UP = {
  enter: "transition-all duration-300",
  enterFrom: "opacity-0 translate-y-48",
  enterTo: "opacity-100 translate-y-0"
};
const TRANSITION_IN_SLIDE_DOWN = {
  enter: "transition-all duration-300",
  enterFrom: "opacity-0 -translate-y-48",
  enterTo: "opacity-100 translate-y-0"
};
const TRANSITION_OUT_SLIDE_DOWN = {
  leave: "transition-all duration-300",
  leaveFrom: "opacity-100 translate-y-0",
  leaveTo: "opacity-0 translate-y-48"
};
const TRANSITION_OUT_SLIDE_UP = {
  leave: "transition-all duration-300",
  leaveFrom: "opacity-100 translate-y-0",
  leaveTo: "opacity-0 -translate-y-48"
};
const TRANSITION_IN_SLIDE_LEFT = {
  enter: "transition-all duration-300",
  enterFrom: "opacity-0 translate-x-48",
  enterTo: "opacity-100 translate-x-0"
};
const TRANSITION_OUT_SLIDE_RIGHT = {
  leave: "transition-all duration-300",
  leaveFrom: "opacity-100 translate-x-0",
  leaveTo: "opacity-0 translate-x-48"
};
const TRANSITION_IN_SLIDE_RIGHT = {
  enter: "transition-all duration-300",
  enterFrom: "opacity-0 -translate-x-48",
  enterTo: "opacity-100 translate-x-0"
};
const TRANSITION_OUT_SLIDE_LEFT = {
  leave: "transition-all duration-300",
  leaveFrom: "opacity-100 translate-x-0",
  leaveTo: "opacity-0 -translate-x-48"
};
const TRANSITION_IN_FADE = {
  enter: "transition-all duration-300",
  enterFrom: "opacity-0",
  enterTo: "opacity-100"
};
const TRANSITION_OUT_FADE = {
  leave: "transition-all duration-300",
  leaveFrom: "opacity-100",
  leaveTo: "opacity-0"
};
const DEFAULT_TRANSITION_DURATION = 300;
export {
  DEFAULT_TRANSITION_DURATION,
  TRANSITION_IN_FADE,
  TRANSITION_IN_SLIDE_DOWN,
  TRANSITION_IN_SLIDE_LEFT,
  TRANSITION_IN_SLIDE_RIGHT,
  TRANSITION_IN_SLIDE_UP,
  TRANSITION_OUT_FADE,
  TRANSITION_OUT_SLIDE_DOWN,
  TRANSITION_OUT_SLIDE_LEFT,
  TRANSITION_OUT_SLIDE_RIGHT,
  TRANSITION_OUT_SLIDE_UP
};
